function v4CoordsToPoints(coordinates) {
    if (!Array.isArray(coordinates)) return [];
    return coordinates
        .filter(c => c && typeof c.latitude === 'number' && typeof c.longitude === 'number')
        .map(c => [c.latitude, c.longitude]);
}

// V4: 1 coord + margin = circle (radius=margin); 2+ coords = polygon with margin buffer.
export function mapV4GeofenceToV3(v4Geofence, accountId, siteUuidToV3Id) {
    const points = v4CoordsToPoints(v4Geofence.coordinates);
    const margin = +v4Geofence.margin || 0;
    const isCircle = points.length === 1;
    const v4SiteId = v4Geofence.site_id || null;
    const siteId = v4SiteId && siteUuidToV3Id?.get?.(v4SiteId) || 0;
    return {
        id: v4Geofence.id,
        uuid: v4Geofence.id,
        accountId: accountId || 0,
        name: v4Geofence.name || '',
        latitude: isCircle ? points[0][0] : 0,
        longitude: isCircle ? points[0][1] : 0,
        radius: margin,
        shape: isCircle ? 'circle' : 'polygon',
        points: isCircle ? [] : points,
        teamIds: null,
        hidden: false,
        locked: false,
        siteId,
        accountName: '',
        source: 'v4',
        v4OwnerId: v4Geofence.owner_id || null,
        v4Data: v4Geofence,
    };
}

// Circle: 1 coord + margin=radius. Polygon: vertex list + margin=radius (buffer).
export function v3GeofenceToV4Body(geofence) {
    const get = (key) => (geofence?.get ? geofence.get(key) : geofence?.[key]);
    const margin = Math.max(0, Math.round(parseFloat(get('radius')) || 0));
    if (get('shape') === 'circle') {
        return {
            coordinates: [{
                latitude: parseFloat(get('latitude')),
                longitude: parseFloat(get('longitude')),
            }],
            margin,
        };
    }
    const coordinates = (get('points') || [])
        .filter(p => Array.isArray(p) && p.length >= 2)
        .map(([latitude, longitude]) => ({ latitude, longitude }));
    return { coordinates, margin };
}
